module.exports = __webpack_public_path__ + "media/images/social-share-button/google_plus-f00551a4bf893df1fe8bf6f395f9d6c5.svg";